var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"debugInfo"},[_c('app-header',{attrs:{"title":_vm.title}}),_c('mt-cell',{attrs:{"title":"LOG按钮"}},[_c('mt-switch',{on:{"change":_vm.changeShowConsole},model:{value:(_vm.showConsole),callback:function ($$v) {_vm.showConsole=$$v},expression:"showConsole"}},[_vm._v(_vm._s(_vm.showConsole?'显示':'隐藏'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }